import React from "react";
import InputText from './InputText';

const InputPassword = props => {
  return <InputText {...props} type="password" />
};

export default InputPassword;
